import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";
import { CSSProperties } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CardBox from "../../../main/components/CardBox";
import { EmptyTable } from "../../clients/components/EmptyState";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export type Item = {
  id?: string;
  name?: string;
  email?: string;
  onClick?: () => void;
  whatsappEnabled?: boolean;
  children?: React.ReactNode;
  cantRemove?: boolean;
};
export default function UserItemsTable(props: {
  hover?: boolean;
  userItems: Item[];
  itemLabel: string;
  onRemove: (item: Item) => void;
  onAddWhatsApp?: (item: Item) => void;
  onRemoveWhatsApp?: (item: Item) => void;
  disableWhatsAppButton?: boolean;
  style?: CSSProperties;
  removeActions?: boolean;
}) {
  const {
    itemLabel,
    userItems,
    onRemove,
    style,
    hover,
    onAddWhatsApp,
    onRemoveWhatsApp,
    disableWhatsAppButton,
  } = props;

  const handleRemoveClick = (event: any, item: any) => {
    event.preventDefault();
    event.stopPropagation();
    onRemove(item);
  };
  const handleRemoveWhatsAppClick = (event: any, item: any) => {
    event.preventDefault();
    event.stopPropagation();
    onRemoveWhatsApp && onRemoveWhatsApp(item);
  };
  const handleAddWhatsAppClick = (event: any, item: any) => {
    event.preventDefault();
    event.stopPropagation();
    onAddWhatsApp && onAddWhatsApp(item);
  };

  return (
    <CardBox
      sx={{
        width: "100%",
        height: "200px",
        maxHeight: "200px",
        overflow: "auto",
      }}
    >
      <TableContainer style={style}>
        <Table size="small" stickyHeader>
          <TableBody>
            {userItems.length > 0 ? (
              userItems.map((item) => {
                return (
                  <TableRow
                    sx={{
                      cursor: item.onClick ? "pointer" : "auto",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                    hover={hover}
                    onClick={item.onClick}
                    key={item.id}
                  >
                    <TableCell
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderBottom: item.children
                          ? "none"
                          : "solid 1px rgba(81, 81, 81, 1)",
                      }}
                      align="left"
                    >
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "14px",
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Box sx={{ display: "flex", flexDirection: "row" }}>
                        {onAddWhatsApp && onRemoveWhatsApp && (
                          <Tooltip
                            title={`${
                              item.whatsappEnabled
                                ? "Desativar WhatsApp"
                                : disableWhatsAppButton
                                ? "Não é possivel adicionar WhatsApp"
                                : "Ativar WhatsApp"
                            }`}
                          >
                            <Box>
                              <IconButton
                                sx={{
                                  width: {
                                    xs: "25px",
                                  },
                                  height: {
                                    xs: "25px",
                                  },
                                  marginLeft: {
                                    xs: "auto",
                                    sm: "10px",
                                  },
                                }}
                                onClick={(event) => {
                                  item.whatsappEnabled
                                    ? handleRemoveWhatsAppClick(event, item)
                                    : disableWhatsAppButton
                                    ? () => {}
                                    : handleAddWhatsAppClick(event, item);
                                  // disableWhatsAppButton
                                  //   ? () => {}
                                  //   : item.whatsappEnabled
                                  //   ? handleRemoveWhatsAppClick(event, item)
                                  //   : handleAddWhatsAppClick(event, item);
                                }}
                                disabled={
                                  item.whatsappEnabled
                                    ? false
                                    : disableWhatsAppButton
                                }
                              >
                                <WhatsAppIcon
                                  color={
                                    item.whatsappEnabled
                                      ? "success"
                                      : "disabled"
                                  }
                                />
                              </IconButton>
                            </Box>
                          </Tooltip>
                        )}
                        {!item.cantRemove && (
                          <Tooltip title={`Remover ${itemLabel}`}>
                            <IconButton
                              sx={{
                                width: {
                                  xs: "25px",
                                },
                                height: {
                                  xs: "25px",
                                },
                                marginLeft: {
                                  xs: "auto",
                                  sm: "10px",
                                },
                              }}
                              onClick={(event) =>
                                handleRemoveClick(event, item)
                              }
                            >
                              <CloseIcon color="error" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </TableCell>
                    {item.children && (
                      <TableCell
                        sx={{
                          borderBottom: !item.children
                            ? "none"
                            : "solid 1px rgba(81, 81, 81, 1)",
                        }}
                      >
                        {item.children}
                      </TableCell>
                    )}
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell
                  sx={{
                    textAlign: "center",
                    borderBottom: "none",
                  }}
                  colSpan={userItems.length}
                >
                  <EmptyTable />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </CardBox>
  );
}
